import { render, staticRenderFns } from "./exc-upload.vue?vue&type=template&id=c880c968"
import script from "./exc-upload.vue?vue&type=script&lang=js"
export * from "./exc-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports